import React, { useState } from 'react';
import apiClient, { permissionMessage } from '../config/axiosConfig';
import './MyEmailPreference.css';

interface MyEmailPreferenceProps {
  locationId: number;
  locationName: string;
  receiveEmails: boolean;
  onChanged: () => void;
}

/**
 * Wie welke locatie beheert is superadmin-werk, maar of je zelf een melding in
 * je mailbox wilt is je eigen keuze. Daarom staat dit schuifje los van het
 * beheerdersscherm.
 */
const MyEmailPreference: React.FC<MyEmailPreferenceProps> = ({
  locationId,
  locationName,
  receiveEmails,
  onChanged,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const toggle = async () => {
    setIsSaving(true);
    setError(null);

    try {
      await apiClient.put(`/me/locations/${locationId}/email-preference`, {
        receive_emails: !receiveEmails,
      });
      onChanged();
    } catch (requestError) {
      setError(permissionMessage(requestError) || 'De instelling kon niet opgeslagen worden.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="my-email-preference">
      <label className="my-email-preference-toggle">
        <input
          type="checkbox"
          checked={receiveEmails}
          onChange={toggle}
          disabled={isSaving}
        />
        <span>
          Stuur mij een e-mail bij een nieuwe reservering op {locationName}
        </span>
      </label>
      {error && <span className="my-email-preference-error">{error}</span>}
    </div>
  );
};

export default MyEmailPreference;
